import {theme as base} from '@chakra-ui/react'
import {FontTheme} from '../types/typography.types'

const fonts: FontTheme = {
    fonts: {
        heading: `'Georgia', 'Noto Sans', ${base.fonts?.heading}`,
        body: `'Arial', 'Noto Sans', ${base.fonts?.body}`,
        primary: `'Georgia', 'Noto Sans', ${base.fonts?.heading}`,
        secondary: `'Arial', 'Noto Sans', ${base.fonts?.body}`,
    },
}

export default fonts
